import { loadStripe } from '@stripe/stripe-js';

// Stripe.js floats a developer-tools assistant bubble over the page with a test key.
// It is for developers only and must never be shown to buyers.
const STRIPE_JS_OPTIONS = { developerTools: { assistant: { enabled: false } } };

/** loadStripe with the portal's Stripe.js options. Use this instead of loadStripe. */
const loadStripeJs = (publishableKey) => loadStripe(publishableKey, STRIPE_JS_OPTIONS);

export default loadStripeJs;
